<vb-modal
  [visible]="isOpen()"
  title="My Account"
  size="md"
  [closable]="!isSaving()"
  [closeOnBackdropClick]="!isSaving()"
  [closeOnEscape]="!isSaving()"
  [showFooter]="false"
  (onCancel)="close()"
  (visibleChange)="onVisibleChange($event)">

  @if (isLoading()) {
    <p class="py-6 text-center text-sm text-base-content/70">Loading your account information...</p>
  } @else if (successMessage()) {
    <vb-alert
      type="success"
      variant="soft"
      [showIcon]="true"
      [message]="successMessage()"
      class="block mb-4"
    />
    <div class="flex justify-end">
      <vb-button variant="primary" size="md" (click)="close()">
        Close
      </vb-button>
    </div>
  } @else {
    @if (errorMessage()) {
      <vb-alert
        type="error"
        variant="soft"
        [showIcon]="true"
        [message]="errorMessage()"
        class="block mb-4"
      />
    }

    <form [formGroup]="form" (ngSubmit)="save()">
      <div class="max-h-[calc(100vh-16rem)] overflow-y-auto pr-1">
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
        <vb-input
          id="firstName"
          name="firstName"
          type="text"
          label="First Name"
          [required]="true"
          [state]="form.controls.firstName.touched && form.controls.firstName.invalid ? 'error' : 'default'"
          formControlName="firstName"
        />
        <vb-input
          id="lastName"
          name="lastName"
          type="text"
          label="Last Name"
          [required]="true"
          [state]="form.controls.lastName.touched && form.controls.lastName.invalid ? 'error' : 'default'"
          formControlName="lastName"
        />
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
        <vb-input
          id="company"
          name="company"
          type="text"
          label="Company"
          formControlName="company"
        />
        <vb-input
          id="title"
          name="title"
          type="text"
          label="Title"
          formControlName="title"
        />
      </div>

      <div class="mb-4">
        <vb-input
          id="address1"
          name="address1"
          type="text"
          label="Street Address"
          formControlName="address1"
        />
      </div>

      <div class="mb-4">
        <vb-input
          id="address2"
          name="address2"
          type="text"
          label="Street Address 2"
          formControlName="address2"
        />
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
        <vb-input
          id="city"
          name="city"
          type="text"
          label="City"
          formControlName="city"
        />
        <vb-input
          id="state"
          name="state"
          type="text"
          label="State"
          formControlName="state"
        />
      </div>

      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
        <vb-input
          id="postalCode"
          name="postalCode"
          type="text"
          label="Postal Code"
          [state]="form.controls.postalCode.touched && form.controls.postalCode.invalid ? 'error' : 'default'"
          formControlName="postalCode"
        />
        <vb-input
          id="phoneNumber"
          name="phoneNumber"
          type="tel"
          label="Phone Number"
          [required]="true"
          [state]="form.controls.phoneNumber.touched && form.controls.phoneNumber.invalid ? 'error' : 'default'"
          formControlName="phoneNumber"
        />
      </div>

      <div class="mb-6">
        <vb-input
          id="userEmail"
          name="userEmail"
          type="email"
          label="Email"
          [value]="userEmail()"
          [disabled]="true"
        />
      </div>
      </div>

      <div class="flex gap-3 justify-end">
        <vb-button
          type="button"
          variant="ghost"
          size="md"
          [disabled]="isSaving()"
          (click)="close()">
          Cancel
        </vb-button>
        <vb-button
          type="submit"
          variant="primary"
          size="md"
          [loading]="isSaving()"
          [disabled]="isSaving() || form.invalid">
          @if (isSaving()) {
            Saving...
          } @else {
            Save Changes
          }
        </vb-button>
      </div>
    </form>
  }
</vb-modal>
